<ngx-spinner bdColor="rgba(0, 0, 0, .3)"
             size="medium"
             color="#fff"
             type="ball-scale-multiple">
  <p style="font-size: 20px; color: #fff">Carregando...</p>
</ngx-spinner>

<ng-container *ngIf="!ies">
  <div class="alert alert-warning alert-custom">
    <p>Não permitido!</p>
  </div>
</ng-container>

<ng-container *ngIf="ies">
  <navbar></navbar>
  <section class="container-fluid" [ngClass]="{'estacioSubHeader': ies.codigo === 1}">
    <div class="container">
      <div class="row" style="padding: 44px 0 39px 0;">

        <div class="col-md-10 header">
          <div>
            <h1>Busca de informações sobre o Currículo Escolar Digital</h1>
            <p id="texto-topo">
              Este site destina-se à busca de informações sobre o Currículo Escolar Digital, em cumprimento à determinação disposta na Instrução Normativa nº 5, de 14 de outubro de 2022, publicada no Diário Oficial da União em 17.10.2022, que aprova a versão 1.05 dos Anexos I, II e III da Instrução Normativa - IN/SESU nº 1, de 15 de dezembro de 2020, que dispõe sobre a regulamentação técnica para a emissão e o registro de diploma de graduação, por meio digital, pelas Instituições de Ensino Superior - IES pertencentes ao Sistema Federal de Ensino.
            </p>
            <!--<p id="subtexto-topo">Informe o número do currículo digital.</p>-->
          </div>
        </div>

        <!--<div class="col-md-5 col-lg-4 offset-lg-1 col-xl-4 offset-xl-1 card-blue-container d-none--d-md-block">

          <div class="card-topo-consulta">
            <div class="row">
              <div class="col-12 content-card">
                <div>
                  <img src="assets/images/cartao.png">
                </div>
                <p>CURRÍCULO DIGITAL</p>
              </div>
            </div>
            <form (submit)="buscaDigital(codigo.value)">
              <input #codigo placeholder="Código de verificação">
              <button type="submit"><i-bs name="arrow-right-short"></i-bs></button>
            </form>
          </div>

        </div>-->
      </div>
    </div>
  </section>

</ng-container>
